import React from 'react';
import { Icon } from '@iconify-icon/react';
import { ActionIcon } from '@mantine/core';
import { useRouter } from 'next/router';

interface BackButtonProps {
  handleClick?: () => void;
}

const BackButton: React.FC<BackButtonProps> = ({ handleClick }) => {
  const router = useRouter();
  return (
    <ActionIcon
      variant="white"
      aria-label="Go back"
      className="flex h-11 w-11 items-center justify-center rounded-xl border border-gray-300 text-gray-800"
      onClick={() => (handleClick ? handleClick() : router.back())}>
      <Icon icon="icon-park-outline:left" className="text-xl text-gray-500" />
    </ActionIcon>
  );
};

export default BackButton;
